import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchLandingpage } from 'src/api/welcome';
import {
    FETCH_LANDINGPAGE,
    requestLandingpage,
    requestLandingpageFailure,
    requestLandingpageSuccess,
} from 'src/store/welcome/actions';

function* fetchLandingpageSaga(action: AnyAction): SagaIterator {
    yield put(requestLandingpage());

    const { error, response } = yield call(fetchLandingpage, action.uuid);

    if (error) yield put(requestLandingpageFailure(error));
    else yield put(requestLandingpageSuccess(response));
}

export function* generateFetchLandingpageWatcher() {
    yield takeLatest(FETCH_LANDINGPAGE, fetchLandingpageSaga);
}
